import React, { useState, useEffect } from 'react';
import {
    Col, Row, FormGroup, Input, Form, Button, Spinner, Modal, ModalHeader, ModalBody
} from 'reactstrap';
import { useForm } from 'react-hook-form';
import Select from 'react-select';
import MaterialTable from 'material-table';

// Api
import concessionaria_api from '../../../../api/concessionaria_api';
import contrato_api from '../../../../api/contrato_api';
import documento_api from '../../../../api/documento_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import { validarCampos, objCampo } from '../../../../helpers/ValidadorDeCampos';
import downloadBase64File from '../../../../helpers/downloadFile';

// style
import { table_translate, table_style } from "../../../../constants/MaterialTable.js";

function initialStateDocumento() {
    return {
        documento_Id: "",
        arquivo: ""
    }
}
export default function ContratoIdentificacao({ contrato, set_contrato }) {
    const { register, errors, handleSubmit, setValue, clearErrors, getValues } = useForm({ mode: "onBlur" });

    //Estado de controle dos erros nos campos dos documentos
    const [errors_documentos, set_errors_documentos] = useState({});

    //Campos obrigatorios da adição de documentos
    const camposDocumentos = [objCampo({ name: "documento_Id", required: true }), objCampo({ name: "arquivo", required: true })];

    //Estado de controle do loading na tela
    const [show_loading, set_show_loading] = useState(false);

    //Estado de controle da visibilidade do modal de documentos
    const [visible_modal, set_visible_modal] = useState(false);

    //Estado de controle para adicionar documento ao contrato
    const [documento, set_documento] = useState(initialStateDocumento);

    //Estado de controle dos documentos do contrato 
    const [contrato_documentos, set_contrato_documentos] = useState([]);

    // Opções do campo de concessionaria e change do campo
    const [options_concessionarias, set_options_concessionarias] = useState([]);

    //Estado de controle do valor da concessionaria
    const [concessionaria_id, set_concessionaria_id] = useState(0);

    const loadOptionsConcessionaria = () => {
        set_show_loading(true);
        concessionaria_api.getAll().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_concessionarias(result.data.filter(f => f.status == "Ativo").map(value => ({ value: value.concessionaria_Id, label: value.identificacao })));
            }
        }).finally(f => set_show_loading(false));
    }

    // Opções de documentos para serem selecionados
    const [options_documentos, set_options_documentos] = useState([]);

    // Função que carrega a lista de documentos
    const loadDocumentos = () => {
        set_show_loading(true);
        documento_api.getAll("Ativo").then(response => {
            if (response.status !== 200) {
                showMessage("Aviso", response.message, 'error', null);
                return;
            }
            const _options_documentos = response.data.map(value => ({ value: value.documento_Id.toString(), label: value.identificacao }));
            set_options_documentos(_options_documentos);
        }).finally(f => set_show_loading(false));
    }

    //Função de salvamento de documento
    const salvarDocumento = () => {
        const _errors = validarCampos(documento, camposDocumentos);
        set_errors_documentos(_errors[0]);
        if (_errors[1].length > 0) {
            return;
        }

        set_contrato_documentos([...contrato_documentos, documento]);
        set_documento(initialStateDocumento());
    }

    const handleChangeConcesionaria = (value) => {
        clearErrors("concessionaria_Id");
        set_concessionaria_id(value);
        setValue("concessionaria_Id", value, true);
    }

    //Função de envio dos dados de identificação do contrato
    const onSubmit = (data) => {
        const json_submit = {
            ...data,
            contratoDocumentos: contrato_documentos.map(value => {
                const contratoDocumento = { ...value };
                delete contratoDocumento.base64;
                return contratoDocumento;
            })
        }
        set_show_loading(true);
        if (!contrato?.contrato_Id) {
            contrato_api.postContrato(json_submit).then(response => {
                if (response.status !== 200) {
                    showMessage("Aviso", response.message, 'error', null);
                    return;
                }
                showMessage("Sucesso", "contrato salvo com sucesso!", 'success', null);
                set_contrato(response.data);
                set_contrato_documentos(response.data.contratoDocumentos);
            }).finally(f => set_show_loading(false));
        } else {
            json_submit.contrato_Id = contrato.contrato_Id;

            contrato_api.putContrato(json_submit).then(response => {
                if (response.status !== 200) {
                    showMessage("Aviso", response.message, 'error', null);
                    return;
                }
                showMessage("Sucesso", "contrato atualizado com sucesso!", 'success', null);
                set_contrato(response.data);
                set_contrato_documentos(response.data.contratoDocumentos);
            }).finally(f => set_show_loading(false));
        }
    }
    const onChangeAnexo = (e) => {
        const FR = new FileReader();

        FR.addEventListener("load", function (evt) {
            const base64 = evt.target.result;
            set_documento({
                ...documento,
                arquivo: base64
            });
        });
        if (e.target.files)
            FR.readAsDataURL(e.target.files[0]);
    }

    //onChange do campo de documento
    const onChangeDocumento = (e) => {
        set_documento({ ...documento, documento_Id: e.value, identificacaoDocumento: e.label });
    }
    const handleRemove = (data) => {
        set_contrato_documentos(contrato_documentos.filter(c => c.documento_Id != data.documento_Id));
    }
    const handleDownload = (rowData) => {
        if (rowData.base64) {
            downloadBase64File(rowData.base64, rowData.identificacaoDocumento);
        } else if (rowData.arquivo) {
            downloadBase64File(rowData.arquivo, rowData.identificacaoDocumento);
        }
    }
    //Estado de controle da visibilidade do modal de documentos
    const toggleModal = () => {
        set_visible_modal(!visible_modal);
    }

    //Função que carrega os dados do formulario
    const loadForm = () => {
        if (contrato && Object.keys(contrato).length > 0) {
            setValue("contrato_Id", contrato.contrato_Id);
            setValue("orgao", contrato.orgao);
            setValue("unidade", contrato.unidade);
            setValue("numeroDotacao", contrato.numeroDotacao);
            setValue("numeroDespesa", contrato.numeroDespesa);
            setValue("emissao", contrato.emissao.split("T")[0]);
            setValue("inicioVigencia", contrato.inicioVigencia.split("T")[0]);
            setValue("fimVigencia", contrato.fimVigencia.split("T")[0]);
            setValue("fonteRecurso", contrato.fonteRecurso);
            setValue("especificacaoDespesa", contrato.especificacaoDespesa);
            setValue("objeto", contrato.objeto);
            setValue("calorContrato", contrato.calorContrato);
            setValue("concessionaria_Id", contrato.concessionaria_Id);
            set_concessionaria_id(contrato.concessionaria_Id);
            setValue("numeroProcesso", contrato.numeroProcesso);
            setValue("identificacao", contrato.identificacao);
            set_contrato_documentos(contrato.contratoDocumentos);
        }
    }
    useEffect(() => {
        loadOptionsConcessionaria();
        loadDocumentos();
        loadForm();
    }, []);

    return (
        <div>
            {show_loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <Modal isOpen={visible_modal} toggle={toggleModal} size="xl">
                <ModalHeader toggle={toggleModal}>Documentos</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col lg="6" md="12" sm="12">
                            <FormGroup>
                                <label className="form-control-label">Documento</label>
                                <Select
                                    name="documento_Id"
                                    options={options_documentos.filter(f => !contrato_documentos.some(c => c.documento_Id == f.value))}
                                    getOptionLabel={o => o.label}
                                    getOptionValue={o => o.value}
                                    value={options_documentos.filter(v => v.value == documento.documento_Id)}
                                    onChange={onChangeDocumento}
                                    classNamePrefix="select"
                                    placeholder="[ Selecione ]"
                                />
                                {errors_documentos.documento_Id && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col lg="6" md="12">
                            <FormGroup>
                                <label className="form-control-label">Arquivo</label>
                                <Input className="form-control"
                                    autocomplete="off"
                                    type="file"
                                    name="arquivo"
                                    onChange={onChangeAnexo}
                                    value={""}
                                    style={{ padding: ".37rem" }}
                                />
                                {errors_documentos.arquivo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col lg="12" md="12" className="d-flex align-items-center justify-content-center">
                            <Button color="success" onClick={salvarDocumento}>
                                + Adicionar
                            </Button>
                        </Col>
                    </Row>
                    <Form>
                        <MaterialTable style={{ minHeight: "auto" }}
                            title=""
                            columns={[
                                { title: 'Identificação', field: 'identificacaoDocumento' }
                            ]}
                            data={contrato_documentos}
                            isLoading={false}
                            options={{
                                ...table_style,
                                filtering: false,
                                exportButton: true
                            }}
                            actions={[
                                (rowData) => {
                                    return {
                                        icon: 'delete',
                                        tooltip: 'Remover',
                                        onClick: (event, rowData) => handleRemove(rowData)
                                    }
                                },
                                (rowData) => {
                                    return {
                                        icon: 'download',
                                        tooltip: 'Download',
                                        onClick: (event, rowData) => handleDownload(rowData)
                                    }
                                },
                            ]}
                            localization={table_translate}
                        />
                    </Form>
                </ModalBody>
            </Modal>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col lg="8" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Identificação</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="text"
                                name="identificacao"
                                innerRef={register({ required: true })}
                            />
                            {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="12" sm="12">
                        <Button className="mt-4 w-100" onClick={toggleModal}>
                            <i className='fas fa-file-alt'></i> Documentos
                        </Button>
                    </Col>
                    <Col lg="4" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Numero do processo</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="text"
                                name="numeroProcesso"
                                innerRef={register({ required: true })}
                            />
                            {errors.numeroProcesso && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Concessionaria</label>
                            <Select
                                name="concessionaria_Id"
                                options={options_concessionarias}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                value={options_concessionarias.filter(f => f.value == concessionaria_id)}
                                onChange={(o) => handleChangeConcesionaria(o.value)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                ref={e => register(
                                    { name: "concessionaria_Id" },
                                    { required: true })
                                }
                            />
                            {errors.concessionaria_Id && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Orgão</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="text"
                                name="orgao"
                                innerRef={register({ required: true })}
                            />
                            {errors.orgao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Unidade</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="text"
                                name="unidade"
                                innerRef={register({ required: true })}
                            />
                            {errors.unidade && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Número dotação</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="text"
                                name="numeroDotacao"
                                innerRef={register({ required: true })}
                            />
                            {errors.numeroDotacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Número despesa</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="text"
                                name="numeroDespesa"
                                innerRef={register({ required: true })}
                            />
                            {errors.numeroDespesa && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>

                    <Col lg="4" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Emissão</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="date"
                                name="emissao"
                                innerRef={register({ required: true })}
                            />
                            {errors.emissao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Inicio vigência</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="date"
                                name="inicioVigencia"
                                innerRef={register({ required: true })}
                            />
                            {errors.inicioVigencia && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Fim vigência</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="date"
                                name="fimVigencia"
                                innerRef={register({ required: true })}
                            />
                            {errors.fimVigencia && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="12" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Fonte recurso</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="textarea"
                                name="fonteRecurso"
                                rows="5"
                                innerRef={register({ required: true })}
                            />
                            {errors.fonteRecurso && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="12" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Especificação da despesa</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="textarea"
                                name="especificacaoDespesa"
                                rows="5"
                                innerRef={register({ required: false })}
                            />
                            {errors.especificacaoDespesa && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>

                    <Col lg="12" md="12" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Objeto</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="textarea"
                                name="objeto"
                                rows="5"
                                innerRef={register({ required: true })}
                            />
                            {errors.objeto && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="12" md="12" sm="12" className="text-center">
                        <Button color="success" type="submit">
                            <i className="fas fa-save"></i>  Salvar
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );

}